import { render, staticRenderFns } from "./area-documentation.component.vue?vue&type=template&id=f18f0b3a"
import script from "./area-documentation.component.ts?vue&type=script&lang=ts&external"
export * from "./area-documentation.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18f0b3a')) {
      api.createRecord('f18f0b3a', component.options)
    } else {
      api.reload('f18f0b3a', component.options)
    }
    module.hot.accept("./area-documentation.component.vue?vue&type=template&id=f18f0b3a", function () {
      api.rerender('f18f0b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/diagram-view-location-form/area-documentation/area-documentation.component.vue"
export default component.exports